import dayjs from 'dayjs';
import { isDefined } from '@fabric-app/utils/guards';

function formatter(value, format) {
  return isDefined(value) ? format(value) : void 0;
}
function isValidAttribute(attribute) {
  return isDefined(attribute.value) && attribute.value !== "";
}
function attributeDateFormatter(dateString) {
  return dayjs(dateString).format("dddd, D MMMM YYYY [at] HH:mm");
}

export { attributeDateFormatter, formatter, isValidAttribute };
//# sourceMappingURL=utils.js.map
